import { render, staticRenderFns } from "./ConfigurationAccountingAccountsCard.vue?vue&type=template&id=1d4ce796&"
import script from "./ConfigurationAccountingAccountsCard.vue?vue&type=script&lang=js&"
export * from "./ConfigurationAccountingAccountsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports